<div class="label-wrapper"
    [ngStyle]="{
       'width': (selectedLabel === 'thermal_1' ? '378px' : '793px'),
       'height': (selectedLabel === 'thermal_1' ? '378px' : 'auto'),
       'min-height': (selectedLabel === 'a4' ? '1122px' : (selectedLabel === 'a4_2' || selectedLabel === 'a4_4' ? '561px' : 'auto')),
       'max-height': (selectedLabel === 'thermal_1' ? '378px' : 'none'),
       'padding': '0',
       'overflow': (selectedLabel === 'thermal_1' ? 'hidden' : 'visible'),
       'border': '2px solid #000',
       'margin': '0 auto',
       'font-family': '\'Poppins\', \'Inter\', sans-serif',
       'color': '#000',
       'box-sizing': 'border-box',
       'background-color': '#fff',
       'position': 'relative',
       'line-height': '1.2'
     }">

  <!-- Header -->
  <table style="width: 100%; border-collapse: collapse; border-bottom: 2px solid #000; margin-bottom: 0;">
    <tr>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px' : '10px'}" style="width: 33%; vertical-align: middle;">
        <img [src]="uploadedImage ? uploadedImage : (base64DefaultLogo || 'https://storage.googleapis.com/komerce/rajaongkir/komship.png')"
             alt="Logo"
             crossOrigin="anonymous"
             referrerpolicy="no-referrer"
             [ngStyle]="{'max-height': selectedLabel === 'thermal_1' ? '20px' : '40px'}" style="display: block;">
      </td>
      <td style="width: 34%; text-align: center; vertical-align: middle;">
        <h1 [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '12px' : '24px'}" style="margin: 0; font-weight: 600; letter-spacing: 2px;">COD</h1>
      </td>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px' : '10px'}" style="width: 33%; text-align: right; vertical-align: middle;">
        <img [src]="base64SapLogo || 'https://storage.googleapis.com/komerce/assets/illustration/sap.png'"
             alt="SAP" [ngStyle]="{'max-height': selectedLabel === 'thermal_1' ? '18px' : '38px'}" style="display: inline-block;">
      </td>
    </tr>
  </table>

  <!-- Resi & Barcode -->
  <div [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '6px' : '15px 10px'}" style="text-align: center; border-bottom: 1.5px solid #000;">
    <h2 [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '12px' : '32px', 'margin-bottom': selectedLabel === 'thermal_1' ? '8px' : '10px'}" style="font-weight: 600; margin-top: 0;">No. Resi : DMP00097808913</h2>
    <div [ngStyle]="{'margin': selectedLabel === 'thermal_1' ? '4px 0' : '10px 0'}" style="display: flex; justify-content: center;">
      <img [src]="base64Barcode || 'https://storage.googleapis.com/komerce/assets/barcode_example.png'"
           [ngStyle]="{'height': selectedLabel === 'thermal_1' ? '35px' : '90px'}" style="width: 85%; max-width: 600px;" alt="barcode">
    </div>
    <div [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '12px' : '34px', 'margin-top': selectedLabel === 'thermal_1' ? '4px' : '5px'}" style="font-weight: 600;">
      Rp. 129.000
    </div>
  </div>

  <!-- Service Info Grid -->
  <!-- A4_2 use 1x4 Grid -->
  <table *ngIf="selectedLabel === 'a4_2'" style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
    <tr>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;">Layanan : <strong>DRGREG</strong></p>
      </td>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;">Asuransi : <strong *ngIf="isInsuranceShow">Tidak Ada</strong></p>
      </td>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;">Berat : <strong>12,002 Kg</strong></p>
      </td>
      <td style="width: 25%; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;">Rute : <strong>BDO - LOP</strong></p>
      </td>
    </tr>
  </table>

  <table *ngIf="selectedLabel === 'a4_4'" style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
    <tr>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;"><strong>Layanan :</strong></p>
        <p style="margin: 0; font-size: 15px;"><strong>DRGREG</strong></p>
      </td>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;"><strong>Asuransi :</strong></p>
        <p style="margin: 0; font-size: 15px;"><strong *ngIf="isInsuranceShow">Tidak Ada</strong></p>
      </td>
      <td style="width: 25%; border-right: 1.5px solid #000; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;"><strong>Berat :</strong></p>
        <p style="margin: 0; font-size: 15px;"><strong>12,002 Kg</strong></p>
      </td>
      <td style="width: 25%; padding: 8px 12px;">
        <p style="margin: 0; font-size: 15px;"><strong>Rute :</strong></p>
        <p style="margin: 0; font-size: 15px;"><strong>BDO - LOP</strong></p>
      </td>
    </tr>
  </table>

  <!-- Others use 2x2 Grid -->
  <table *ngIf="selectedLabel !== 'a4_2' && selectedLabel !== 'a4_4'" style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
    <tr>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px 6px' : '8px 12px'}" style="width: 50%; border-right: 1.5px solid #000; border-bottom: 1.5px solid #000;">
        <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '15px'}" style="margin: 0;">Layanan : <strong>DRGREG</strong></p>
      </td>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px 6px' : '8px 12px'}" style="width: 50%; border-bottom: 1.5px solid #000;">
        <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '15px'}" style="margin: 0;">Berat : <strong>12,002 Kg</strong></p>
      </td>
    </tr>
    <tr>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px 6px' : '8px 12px'}" style="width: 50%; border-right: 1.5px solid #000;">
        <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '15px'}" style="margin: 0;">Asuransi : <strong *ngIf="isInsuranceShow">Tidak Ada</strong></p>
      </td>
      <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '4px 6px' : '8px 12px'}" style="width: 50%;">
        <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '15px'}" style="margin: 0;">Rute : <strong>BDO - LOP</strong></p>
      </td>
    </tr>
  </table>

  <!-- Sender & Receiver Block -->
  <div style="position: relative; border-bottom: 1.5px solid #000; display: table; width: 100%;">
    <!-- Watermark -->
    <div *ngIf="isWatermarkShow" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; display: flex; align-items: center; justify-content: center; pointer-events: none;">
      <img [src]="base64Watermark || 'https://storage.googleapis.com/komerce/assets/logo/komship_gray.png'" style="max-width: 50%;" alt="watermark">
    </div>

    <!-- Side by Side Layout -->
    <table *ngIf="selectedLabel !== 'a4_4'" style="width: 100%; border-collapse: collapse; position: relative; z-index: 1;">
      <tr>
        <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '6px' : '15px'}" [style.border-right]="selectedLabel === 'thermal_1' ? 'none' : '1.5px solid #000'" style="width: 50%; vertical-align: top;">
          <h3 [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '9px' : '18px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '10px'}" style="font-weight: 600; margin-top: 0;">Pengirim:</h3>
          <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7.5px' : '14px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '5px'}" style="font-weight: 600; margin-top: 0;">Fian Store Gaming</p>
          <p *ngIf="isPhoneSenderShow" [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7.5px' : '14px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '10px'}" style="font-weight: 600; margin-top: 0;">081227554231</p>
          <p *ngIf="isAddressSenderShow" [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '14px'}" style="line-height: 1.2; margin: 0;">Tunjungmuli, Kab. Purbalingga, Jawa Tengah, TUNJUNGMULI, KARANGMONCOL, PURBALINGGA, JAWA TENGAH, 53355</p>
        </td>
        <td [ngStyle]="{'padding': selectedLabel === 'thermal_1' ? '6px' : '15px'}" style="width: 50%; vertical-align: top;">
          <h3 [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '9px' : '18px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '10px'}" style="font-weight: 600; margin-top: 0;">Penerima:</h3>
          <p *ngIf="!isNameReceiverShow" [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7.5px' : '14px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '5px'}" style="font-weight: 700; margin-top: 0;">Roblah</p>
          <p *ngIf="isNameReceiverShow" [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7.5px' : '14px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '5px'}" style="font-weight: 700; margin-top: 0;">Roxxxxxxx</p>
          <p *ngIf="isPhoneReceiverShow" [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7.5px' : '14px', 'margin-bottom': selectedLabel === 'thermal_1' ? '2px' : '10px'}" style="font-weight: 700; margin-top: 0;">0812225654231</p>
          <p [ngStyle]="{'font-size': selectedLabel === 'thermal_1' ? '7px' : '14px'}" style="line-height: 1.2; margin: 0;">Jl. Melati Raya No. 27, RT 04/RW 02, Kelurahan Sukamaju Utara, Kecamatan Cibinong, Kabupaten Bogor, Provinsi Jawa Barat 16911, Indonesia. Patokan dekat Taman Kota, rumah cat putih, pagar hitam, gerbang besi. Akses mudah mobil dan motor. 24 jam aman. Siap.</p>
        </td>
      </tr>
    </table>
    <table *ngIf="selectedLabel === 'a4_4'" style="width: 100%; border-collapse: collapse; position: relative; z-index: 1;">
      <tr>
        <td style="padding: 15px; width: 50%; vertical-align: top;">
          <h3 style="font-size: 18px; margin-bottom: 10px; font-weight: 600; margin-top: 0;">Pengirim:</h3>
          <p style="font-size: 14px; margin-bottom: 5px; font-weight: 600; margin-top: 0;">Fian Store Gaming</p>
          <p *ngIf="isPhoneSenderShow" style="font-size: 14px; margin-bottom: 10px; font-weight: 600; margin-top: 0;">081227554231</p>
          <p *ngIf="isAddressSenderShow" style="font-size: 14px; line-height: 1.2; margin: 0;">Tunjungmuli, Kab. Purbalingga, Jawa Tengah, TUNJUNGMULI, KARANGMONCOL, PURBALINGGA, JAWA TENGAH, 53355</p>
        </td>
        <td style="padding: 15px; width: 50%; vertical-align: top;">
          <h3 style="font-size: 18px; margin-bottom: 10px; font-weight: 600; margin-top: 0;">Penerima:</h3>
          <p *ngIf="!isNameReceiverShow" style="font-size: 14px; margin-bottom: 5px; font-weight: 700; margin-top: 0;">Roblah</p>
          <p *ngIf="isNameReceiverShow" style="font-size: 14px; margin-bottom: 5px; font-weight: 700; margin-top: 0;">Roxxxxxxx</p>
          <p *ngIf="isPhoneReceiverShow" style="font-size: 14px; margin-bottom: 10px; font-weight: 700; margin-top: 0;">0812225654231</p>
          <p style="font-size: 14px; line-height: 1.2; margin: 0;">Jl. Melati Raya No. 27, RT 04/RW 02, Kelurahan Sukamaju Utara, Kecamatan Cibinong, Kabupaten Bogor, Provinsi Jawa Barat 16911, Indonesia. Patokan dekat Taman Kota, rumah cat putih, pagar hitam, gerbang besi. Akses mudah mobil dan motor. 24 jam aman. Siap.</p>
        </td>
      </tr>
    </table>
  </div>

  <!-- Footer Others Ordering -->
  <ng-container *ngIf="selectedLabel !== 'a4'">

    <!-- Thermal: Meta Info → Warnings → Package Details -->
    <ng-container *ngIf="selectedLabel === 'thermal_1'">
      <!-- Meta Info -->
      <table style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
        <tr>
          <td style="padding: 4px 6px; vertical-align: middle;">
            <p style="margin: 0; font-size: 7px; font-weight: 700;">Order ID : 192038192039812</p>
          </td>
          <td style="padding: 4px 6px; text-align: right; vertical-align: middle;">
            <p style="margin: 0; font-size: 6px;"><strong>Dicetak pada 15/04/2022, pukul 13.52 WIB</strong></p>
          </td>
        </tr>
      </table>

      <!-- Warnings -->
      <div style="padding: 4px 6px; border-bottom: 1.5px solid #000;">
        <p style="font-size: 6px; font-style: italic; margin: 0 0 1px 0; color: #333;">* Kurir — Mohon hubungi pembeli untuk konfirmasi pengiriman</p>
        <p style="font-size: 6px; font-style: italic; margin: 0; color: #333;">* Penerima — Jangan terima paket bila bukan atas nama Anda atau orang dikenal, pastikan Anda benar memesan paket</p>
      </div>

      <!-- Package Details -->
      <div style="padding: 4px 6px;">
        <p *ngIf="isQuantityShow" style="font-size: 7px; font-weight: 600; margin: 0 0 2px 0;">Kuantitas : 1</p>
        <p *ngIf="isPackageShow" style="font-size: 7px; font-weight: 600; margin: 0 0 2px 0;">ISI PAKET : 1 Testing utk edit berat produk 12kg</p>
        <p style="font-size: 7px; font-weight: 600; margin: 0;">Catatan Order : Celana panjang 60 cm warna putih, detail letter U, harap dicek sebelum dikirim, ukuran sesuai benar</p>
      </div>
    </ng-container>

    <!-- Non-thermal (a4_2, a4_4): Package Details → Meta Info → Warnings -->
    <ng-container *ngIf="selectedLabel !== 'thermal_1'">
      <!-- Package Details -->
      <div style="padding: 15px 15px; border-bottom: 1.5px solid #000;">
        <p *ngIf="isQuantityShow" style="font-size: 14px; font-weight: 600; margin: 0 0 15px 0;">Kuantitas : 1</p>
        <p *ngIf="isPackageShow" style="font-size: 14px; font-weight: 600; margin: 0 0 15px 0;">ISI PAKET : 1 Testing utk edit berat produk 12kg</p>
        <p style="font-size: 14px; font-weight: 600; margin: 0;">Catatan Order : Celana panjang 60 cm warna putih, detail letter U, harap dicek sebelum dikirim, ukuran sesuai benar</p>
      </div>

      <!-- Meta Info -->
      <table style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
        <tr>
          <td style="padding: 10px 15px; vertical-align: middle;">
            <p style="margin: 0; font-size: 15px; font-weight: 700;">Order ID : 192038192039812</p>
          </td>
          <td style="padding: 10px 15px; text-align: right; vertical-align: middle;">
            <p style="margin: 0; font-size: 13px;"><strong>Dicetak pada 15/04/2022, pukul 13.52 WIB</strong></p>
          </td>
        </tr>
      </table>

      <!-- Warnings -->
      <div style="padding: 10px 15px;">
        <p style="font-size: 12px; font-style: italic; margin: 0 0 5px 0; color: #333;">* Kurir — Mohon hubungi pembeli untuk konfirmasi pengiriman</p>
        <p style="font-size: 12px; font-style: italic; margin: 0; color: #333;">* Penerima — Jangan terima paket bila bukan atas nama Anda atau orang dikenal, pastikan Anda benar memesan paket</p>
      </div>
    </ng-container>

  </ng-container>

  <!-- Footer A4 Ordering -->
  <ng-container *ngIf="selectedLabel === 'a4'">
    <!-- Package Details -->
    <div style="padding: 15px 15px; border-bottom: 1.5px solid #000;">
      <p *ngIf="isQuantityShow" style="font-size: 14px; font-weight: 600; margin: 0 0 15px 0;">Kuantitas : 1</p>
      <p *ngIf="isPackageShow" style="font-size: 14px; font-weight: 600; margin: 0 0 15px 0;">ISI PAKET : 1 Testing utk edit berat produk 12kg</p>
      <p style="font-size: 14px; font-weight: 600; margin: 0;">Catatan Order : Celana panjang 60 cm warna putih, detail letter U, harap dicek sebelum dikirim, ukuran sesuai benar</p>
    </div>

    <!-- Meta Info -->
    <table style="width: 100%; border-collapse: collapse; border-bottom: 1.5px solid #000;">
      <tr>
        <td style="padding: 10px 15px; vertical-align: middle;">
          <p style="margin: 0; font-size: 15px; font-weight: 700;">Order ID : 192038192039812</p>
        </td>
        <td style="padding: 10px 15px; text-align: right; vertical-align: middle;">
          <p style="margin: 0; font-size: 13px;"><strong>Dicetak pada 15/04/2022, pukul 13.52 WIB</strong></p>
        </td>
      </tr>
    </table>

    <!-- Warnings -->
    <div style="padding: 10px 15px;">
      <p style="font-size: 12px; font-style: italic; margin: 0 0 5px 0; color: #333;">* Kurir — Mohon hubungi pembeli untuk konfirmasi pengiriman</p>
      <p style="font-size: 12px; font-style: italic; margin: 0; color: #333;">* Penerima — Jangan terima paket bila bukan atas nama Anda atau orang dikenal, pastikan Anda benar memesan paket</p>
    </div>
  </ng-container>

</div>
<p class="new-page"></p>
